<template>
  <div>
    <div v-if="request_quotation.service_type == 3">
      <b-row>
        <b-col cols="12" class="pt-1">
          <h4>Freight Informations</h4>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider :name="request_quotation.service_type == 1 ? 'AOL' : 'POL'" #default="{ errors }"
            rules="required">
            <b-form-group>
              <label>{{ request_quotation.service_type == 1 ? "AOL" : "POL"
              }}<font class="red">*</font>
              </label>
              <div class="d-flex">
                <!-- <Select2
                      :class="errors.length > 0 ? 'is-invalid' : null"
                      :disabled="readonly"
                      placeholder="AOL/POL"
                      class="w-100"
                      v-model="request_quotation.pol_port"
                      :options="ports"
                    /> -->
                <Select4 v-model="request_quotation.pol_port" :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="AOL/POL" :disabled="readonly" :options="{
                    value: 'code',
                    label: 'name',
                    data: ports,
                    fields: [
                      { field: 'code', label: 'Code' },
                      { field: 'name', label: 'Name' },
                      { field: 'type', label: 'Service' },
                      {
                        field: 'country_code',
                        label: 'Country Code',
                      },
                    ],
                  }" />
                <!-- <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary" :disabled="readonly"
                  @click.once="getDataPolPod" v-if="!isCustomer" v-b-tooltip.hover
                  title="Data synchronization with FAST" :key="buttonKey" class="btn-icon ml-1">
                  <feather-icon icon="RefreshCwIcon" />
                </b-button> -->
              </div>

              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider :name="request_quotation.service_type == 1 ? 'AOD' : 'POD'" #default="{ errors }"
            rules="required">
            <b-form-group>
              <label>{{ request_quotation.service_type == 1 ? "AOD" : "POD"
              }}<font class="red">*</font></label>

              <!-- <Select2
                    :class="errors.length > 0 ? 'is-invalid' : null"
                    :disabled="readonly"
                    placeholder="AOD/POL"
                    v-model="request_quotation.pod_port"
                    :options="ports"
                  /> -->
              <Select4 v-model="request_quotation.pod_port" :class="errors.length > 0 ? 'is-invalid' : null"
                placeholder="AOD/POL" :disabled="readonly" :options="{
                  value: 'code',
                  label: 'name',
                  data: ports,
                  fields: [
                    { field: 'code', label: 'Code' },
                    { field: 'name', label: 'Name' },
                    { field: 'type', label: 'Service' },
                    {
                      field: 'country_code',
                      label: 'Country Code',
                    },
                  ],
                }" />

              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Payment Terms" #default="{ errors }" rules="">
            <b-form-group>
              <label>Payment Terms</label>
              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Payment Terms"
                v-model="request_quotation.paymentTerms" :options="$Options.paymentTerms" />
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" :lg="step == 'booking' || step == 'view-quotation-booking' ? 6 : 4">
          <validation-provider name="Cargo ready" #default="{ errors }" rules="required">
            <b-form-group>
              <label>Cargo ready<font class="red">*</font></label>
              <date-picker ref="datePicker" v-model="request_quotation.cargo_ready" type="datetime" class="w-full"
                :class="errors.length > 0 ? 'is-invalid' : null" value-type="format" :disabled="readonly"
                title-format="DD-MM-YYYY" time-title-format="DD-MM-YYYY" placeholder="Select datetime"
                :show-time-panel="showTimePanel" format="DD-MM-YYYY HH:mm" @close="handleOpenChange">
                <template v-slot:footer>
                  <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                    {{ showTimePanel ? "Date" : "Time" }}
                  </button>
                </template>
              </date-picker>
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!--  Carrier -->

        <b-col cols="12" :lg="step == 'booking' || step == 'view-quotation-booking' ? 6 : 4">
          <validation-provider name="Carrier" #default="{ errors }" rules="">
            <b-form-group>
              <label>Carrier</label>
              <Select4 v-model="request_quotation.shipping_line" :class="[
                errors.length > 0 ? 'is-invalid' : null,
                readonly == true ? 'remove' : '',
              ]" placeholder="Carrier" :disabled="readonly" :options="{
  value: 'id',
  label: 'text',
  data: shipping_lines,
  fields: [
    { field: 'code', label: 'Code' },
    { field: 'name', label: 'Shipping Line' },
  ],
}" />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="4" v-if="step != 'view-quotation-booking' && step != 'booking'">
          <b-form-group>
            <label>Volume (Monthly)</label>
            <!-- <Select2
                  :disabled="readonly"
                  placeholder="Volume (Monthly)"
                  v-model="request_quotation.volume"
                  :options="volumes"
                /> -->
            <b-form-input :disabled="readonly" v-model="request_quotation.volume" placeholder="Volume (Monthly)" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row v-if="step == 'booking' || step == 'view-quotation-booking'">
        <b-col cols="6">
          <validation-provider name="ETD" #default="{ errors }" rules="">
            <b-form-group>
              <!-- <label>ETD </label> -->
              <!-- <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                :disabled="readonly"
                v-model="request_quotation.etd"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              /> -->

              <label>ETD </label>
              <date-picker ref="datePicker" v-model="request_quotation.etd" type="date" :title="request_quotation.etd"
                class="w-full" :class="errors.length > 0 ? 'is-invalid' : null" value-type="format"
                title-format="DD/MM/YY" :disabled="readonly" time-title-format="DD/MM/YY" placeholder="Select date"
                :show-time-panel="showTimePanel" format="DD/MM/YY" @close="handleOpenChange">
              </date-picker>
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="6">
          <validation-provider name="ETA" #default="{ errors }" rules="">
            <b-form-group>
              <!-- <label>ETA</label>
              <b-form-datepicker
                :state="errors.length > 0 ? false : null"
                v-model="request_quotation.eta"
                :disabled="readonly"
                :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }"
                locale="vi-VN"
              /> -->

              <label>ETA </label>
              <date-picker ref="datePicker" v-model="request_quotation.eta" type="date" :title="request_quotation.eta"
                class="w-full" :class="errors.length > 0 ? 'is-invalid' : null" value-type="format"
                title-format="DD/MM/YY" :disabled="readonly" time-title-format="DD/MM/YY" placeholder="Select date"
                :show-time-panel="showTimePanel" format="DD/MM/YY" @close="handleOpenChange">
              </date-picker>
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="pt-1">
          <h4>Cargo Information</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="4">
          <validation-provider name="Commodity" #default="{ errors }" rules="required">
            <b-form-group>
              <label>Commodity<font class="red">*</font></label>
              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Commodity"
                v-model="request_quotation.goods_type" :options="goods_types" />
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Commodity description" #default="{ errors }" rules="">
            <b-form-group>
              <label>Commodity description</label>
              <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="request_quotation.mo_ta" placeholder="Commodity description" />
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Gross Weight (kgs)" #default="{ errors }" rules="">
            <b-form-group>
              <label>Total Gross Weight (kg)</label>
              <cleave :state="errors.length > 0 ? false : null" :options="$Utils.CONSTANTS.cleaveNumeral"
                :disabled="readonly" v-model="request_quotation.trong_luong" class="form-control"
                placeholder="Gross Weight (kgs)" />
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <!-- -->
      </b-row>
      <b-row>
        <b-col cols="12" lg="4">
          <b-form-group>
            <label>Measurement (cbm)</label>
            <cleave :options="$Utils.CONSTANTS.cleaveNumeral" :disabled="readonly" v-model="request_quotation.so_khoi"
              class="form-control" placeholder="Measurement (kgs)" />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="4">
          <validation-provider name="Handled type" #default="{ errors }" rules="">
            <b-form-group>
              <label>Handled type</label>
              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Handled type"
                v-model="request_quotation.handled_type" :options="handed_types" />
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="4">
          <validation-provider name="Dimension" #default="{ errors }" rules="">
            <b-form-group>
              <label>Dimension</label>
              <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="request_quotation.dimension" placeholder="Dimension" />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="6">
          <validation-provider name="Package type" #default="{ errors }" rules="">
            <b-form-group>
              <label>Package type</label>

              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Package type"
                v-model="request_quotation.package_type" :options="cont_types.filter((i) => i.group === 'packaging')" />
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        <b-col cols="12" lg="6">
          <validation-provider name="Package Number" #default="{ errors }" rules="">
            <b-form-group>
              <label>Package Number</label>
              <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="request_quotation.packageNumber" placeholder="Package Number" />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row v-if="request_quotation.has_van_trucking">
        <b-col cols="12" class="pt-1">
          <h4>Shipment Informations</h4>
        </b-col>
      </b-row>
      <b-row v-if="
        (step == 'booking' || step == 'view-quotation-booking') &&
        request_quotation.has_van_trucking
      ">
        <b-col cols="12" lg="6">
          <b-form-group>
            <label>Booking/HBL/INV</label>
            <b-form-input :disabled="readonly" placeholder="Booking/HBL/INV" v-model="request_quotation.HBL" />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <label>Shipping Type</label>
            <Select2 :disabled="readonly" placeholder="Shipping Type" v-model="request_quotation.shippingType" :options="
              request_quotation.service_type == 5
                ? transport_types.filter((i) => [1, 2, 3, 4].includes(i.id))
                : request_quotation.service_type == 6
                  ? transport_types.filter((i) => [1, 2, 3, 4].includes(i.id))
                  : transport_types.filter((i) => [1, 2].includes(i.id))
            " />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row v-if="request_quotation.has_van_trucking">
        <b-col cols="12" lg="6">
          <validation-provider name="Truck Type" #default="{ errors }" rules="">
            <b-form-group>
              <label>Truck Type</label>
              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Truck Type"
                v-model="request_quotation.truck_type" :options="cont_types.filter((i) => i.group === 'van truck')" />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="Quantity" #default="{ errors }" rules="">
            <b-form-group>
              <label>Quantity</label>
              <b-form-input placeholder="Quantity" type="number" :state="errors.length > 0 ? false : null"
                :disabled="readonly" v-model="request_quotation.so_luong" />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <section v-if="request_quotation.has_van_trucking">
        <b-row v-if="
          step == 'created-quotation' ||
          step == 'view-created-quotation' ||
          (step == 'view-quotation-booking' &&
            (request_quotation.pickup_region != null ||
              request_quotation.other_pickup_region) &&
            step != 'booking')
        ">
          <b-col cols="12" lg="6">
            <validation-provider name="Pick up" #default="{ errors }" rules="required">
              <b-form-group>
                <label>Pick up<font class="red">*</font></label>
                <div class="d-flex align-items-center">
                  <Select2 :class="errors.length > 0 ? 'is-invalid' : null" class="hide_select" :disabled="readonly"
                    v-if="!request_quotation.isHideShows" placeholder="Pick up"
                    v-model="request_quotation.pickup_region" :options="regions" />
                  <b-form-input v-if="request_quotation.isHideShows" :disabled="readonly"
                    v-model="request_quotation.other_pickup_region" placeholder="Enter pick up " />
                  <b-form-checkbox :disabled="readonly" v-on:change="hideShowsi" v-model="request_quotation.isHideShows"
                    class="check_input">Other
                  </b-form-checkbox>
                </div>
                <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider name="Delivery" #default="{ errors }" rules="required">
              <b-form-group>
                <label>Delivery<font class="red">*</font></label>
                <div class="d-flex align-items-center">
                  <Select2 :class="errors.length > 0 ? 'is-invalid' : null" class="hide_select" :disabled="readonly"
                    placeholder="Delivery" v-if="!request_quotation.isHideShowPk"
                    v-model="request_quotation.delivery_region" :options="regions" />
                  <b-form-input :disabled="readonly" v-if="request_quotation.isHideShowPk"
                    v-model="request_quotation.other_delivery_region" placeholder="Enter pick up" />
                  <b-form-checkbox :disabled="readonly" v-on:change="hideShowsPk"
                    v-model="request_quotation.isHideShowPk" class="check_input">Other
                  </b-form-checkbox>
                </div>
                <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>

        <b-row v-else>
          <b-col cols="12" lg="6">
            <validation-provider name="Pick up" #default="{ errors }" rules="required">
              <b-form-group>
                <label>Pick up<font class="red">*</font></label>
                <div class="d-flex align-items-center">
                  <Select4 v-model="request_quotation.pickup_location" :key="countRq" :class="
                    errors.length > 0
                      ? 'is-invalid hide_select'
                      : 'hide_select'
                  " placeholder="Enter Pick up " v-if="!request_quotation.isHideShows" :disabled="readonly" :options="{
  value: 'id',
  label: 'text',
  data: locations,
  fields: [
    { field: 'abbreviations', label: 'Abbreviations' },
    { field: 'name', label: 'Location' },
    {
      field: 'address',
      label: 'Address',
    },
  ],
}" />
                  <b-form-input :disabled="readonly" v-if="request_quotation.isHideShows"
                    v-model="request_quotation.other_pickup_location" placeholder="Enter pick up " />
                  <b-form-checkbox :disabled="readonly" v-on:change="hideShowsi" v-model="request_quotation.isHideShows"
                    class="check_input">Other
                  </b-form-checkbox>
                </div>
                <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col cols="12" lg="6">
            <validation-provider name="Delivery" #default="{ errors }" rules="required">
              <b-form-group>
                <label>Delivery<font class="red">*</font></label>
                <div class="d-flex align-items-center">
                  <Select4 v-model="request_quotation.delivery_location" :key="countRq" :class="
                    errors.length > 0
                      ? 'is-invalid hide_select'
                      : 'hide_select'
                  " placeholder="Enter Delivery " v-if="!request_quotation.isHideShowPk" :disabled="readonly"
                    :options="{
                      value: 'id',
                      label: 'text',
                      data: locations,
                      fields: [
                        { field: 'abbreviations', label: 'Abbreviations' },
                        { field: 'name', label: 'Location' },
                        {
                          field: 'address',
                          label: 'Address',
                        },
                      ],
                    }" />
                  <b-form-input v-if="request_quotation.isHideShowPk" :disabled="readonly"
                    v-model="request_quotation.other_delivery_location" placeholder="Enter pick up" />
                  <b-form-checkbox :disabled="readonly" v-on:change="hideShowsPk"
                    v-model="request_quotation.isHideShowPk" class="check_input">Other
                  </b-form-checkbox>
                </div>
                <small class="text-danger" v-show="errors.length > 0">{{
                    errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </section>

      <b-row v-if="
        request_quotation.has_van_trucking &&
        (step == 'booking' || step == 'view-quotation-booking')
      ">
        <b-col cols="12" lg="6">
          <b-form-group>
            <label>Pick up date</label>

            <section>
              <date-picker ref="datePicker" v-model="request_quotation.pick_up_date" type="datetime" class="w-full"
                :disabled="readonly" value-type="format" title-format="DD-MM-YYYY" time-title-format="DD-MM-YYYY"
                placeholder="Select datetime" :show-time-panel="showTimePanel" format="DD-MM-YYYY HH:mm"
                @close="handleOpenChange">
                <template v-slot:footer>
                  <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                    {{ showTimePanel ? "Date" : "Time" }}
                  </button>
                </template>
              </date-picker>
            </section>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <label>Delivery Date</label>

            <section>
              <date-picker ref="datePicker" v-model="request_quotation.delivery_date"
                :disabled-date="disabledRangeDelivery" type="datetime" class="w-full" value-type="format"
                :disabled="readonly" title-format="DD-MM-YYYY" time-title-format="DD-MM-YYYY"
                placeholder="Select datetime" :show-time-panel="showTimePanel" format="DD-MM-YYYY HH:mm"
                @close="handleOpenChange">
                <template v-slot:footer>
                  <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                    {{ showTimePanel ? "Date" : "Time" }}
                  </button>
                </template>
              </date-picker>
            </section>
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="PIC pick up" #default="{ errors }" rules="">
            <b-form-group>
              <label>PIC pick up</label>
              <b-form-input placeholder="PIC pick up" :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="request_quotation.PICPickUp" />
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="PIC Delivery" #default="{ errors }" rules="">
            <b-form-group>
              <label>PIC Delivery</label>
              <b-form-input placeholder="PIC Delivery" :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="request_quotation.PICDelivery" />
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row v-if="request_quotation.service_type == 1">
        <b-col cols="12" class="pt-1">
          <h4>Intended schedule</h4>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="From" #default="{ errors }" rules="required">
            <b-form-group>
              <label>From<font class="red">*</font></label>
              <b-form-datepicker :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="request_quotation.from_date" :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }" locale="vi-VN" />
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="To" #default="{ errors }" rules="required">
            <b-form-group>
              <label>To<font class="red">*</font></label>
              <b-form-datepicker :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="request_quotation.to_date" :date-format-options="{
                  year: 'numeric',
                  month: 'numeric',
                  day: 'numeric',
                }" locale="vi-VN" />
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" lg="4" class="pt-1">
          <h4>Other service</h4>
        </b-col>
        <b-col cols="3" class="pt-1">
          <b-form-checkbox :disabled="readonly" v-model="request_quotation.has_customs">Customs services
          </b-form-checkbox>
        </b-col>
        <b-col cols="3" class="pt-1">
          <b-form-checkbox :disabled="readonly" v-model="request_quotation.has_van_trucking">Van trucking
          </b-form-checkbox>
        </b-col>
      </b-row>
      <b-row v-if="request_quotation.has_customs">
        <b-col cols="12" lg="12" class="pt-1">
          <h4>Customs declaration information</h4>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <label>Customs type</label>
            <Select2 :disabled="readonly" placeholder="Customs type" v-model="request_quotation.customs_type"
              :options="customs_types" />
          </b-form-group>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="Business type" #default="{ errors }" rules="">
            <b-form-group>
              <label>Business type</label>
              <Select2 :class="errors.length > 0 ? 'is-invalid' : null" :disabled="readonly" placeholder="Business type"
                v-model="request_quotation.business_type" :options="business_types" />
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <validation-provider name="Place of Custom declaration" #default="{ errors }" rules="">
            <b-form-group>
              <label>Place of Custom declaration</label>
              <b-form-input :state="errors.length > 0 ? false : null" :disabled="readonly"
                v-model="request_quotation.customs_addr" placeholder="Place of Custom declaration" />
              <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" lg="6">
          <b-form-group>
            <label>HS Code</label>
            <b-form-input :disabled="readonly" v-model="request_quotation.hs_code" placeholder="HS Code" />
          </b-form-group>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12">
          <b-form-group>
            <label>Notes</label>
            <b-form-textarea rows="11" :disabled="readonly" v-model="request_quotation.notes" placeholder="Notes" />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- multi file upload starts -->
      <b-row v-if="!readonly">
        <b-col cols="12">
          <AttachFile ref="attachFile" />
        </b-col>
      </b-row>
    </div>
  </div>
</template>
 
<script>
import { VBTooltip } from "bootstrap-vue";
import Select2 from "v-select2-component";
import useJwt from "@/auth/jwt/useJwt";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import FeatherIcon from "@/@core/components/feather-icon/FeatherIcon.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import AttachFile from "@/views/wr1/quotation/from-booking/components/AttachFile.vue";
import { mapState, mapActions } from "vuex";
import Ripple from "vue-ripple-directive";

import { $ctx } from "@themeConfig";
import moment from "moment";
export default {
  props: {
    request: { default: null },
    readonly: { default: false },
    isCustomer: { default: false },
    step: { default: "booking" },
  },
  components: {
    ValidationProvider,
    ValidationObserver,

    Select2,
    vueDropzone: vue2Dropzone,
    FeatherIcon,
    AttachFile,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  watch: {
    "request_quotation.company_id": function (n, o) {
      if (
        !this.readonly &&
        (this.userData.userType ==
          this.$Utils.CONSTANTS.USER_TYPE_O.Admin_Sale ||
          this.userData.userType == this.$Utils.CONSTANTS.USER_TYPE_O.Admin)
      ) {
        useJwt
          .get("wr1?objectType=CustomerListCompany", { params: { search: n } })
          .then((response) => {
            this.customer_list_options = this.formatOption(
              response.data.result
            );
            if (this.request_quotation.customer_id == null) {
              this.request_quotation.customer_id =
                this.customer_list_options.filter(
                  (e) => e.user_type == 2
                )[0]?.code;
            }
          });
      }
    },
    "request_quotation.customer_id"(n) {
      this.useName = n;
    },
    useName(n) {
      if (n) {
        useJwt
          .get("getLocationsByUserId", {
            params: { page: 1, pageSize: 2000, userId: n },
          })
          .then((response) => {
            this.locationsByUser = response.data.result.map((e) => {
              const result = {};
              result.text =
                e.abbreviations + " - " + e.detail_address || e.location;
              result.id = e.location_id;
              result.name = e.location;
              result.abbreviations = e.abbreviations;

              result.address = e.detail_address || e.location;

              return result;
            });
            this.countRq++;
          });
      }
    },

    ...["request_quotation.so_khoi", "request_quotation.trong_luong"].reduce(
      (watchers, key) => ({
        ...watchers,
        [key](newVal, oldVal) {
          var vm = this;

          if (vm.request_quotation.service_type == 1) {
            vm.request_quotation.trong_luong >
              vm.request_quotation.so_khoi * 167
              ? (vm.request_quotation.totalChargeWeight =
                vm.request_quotation.trong_luong)
              : (vm.request_quotation.totalChargeWeight =
                vm.request_quotation.so_khoi * 167);
          }
        },
      }),
      {}
    ),
  },
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",
    ]),
    shippingTypeOptions() {
      return [...this.locations, ...this.regions];
    },
    company_list() {
      return this.companyItems;
    },
    locations() {
      this.countRq++;

      return [...this.locationsByUser, ...this.allLocationsPublic];
    },
    locationsNoService() {
      return [...this.locationsByUser, ...this.allLocationsPublicNoServices];
    },
    allLocationsPublicNoServices() {
      return this.$store.state.masterData.locations.filter((item) =>
        [1, 2, 3].includes(item.location_type_id)
      );
    },
    allLocationsPublic() {
      return this.$store.state.masterData.locations.filter((item) =>
        [1, 2, 3, 5].includes(item.location_type_id)
      );
    },
  },
  data() {
    return {
      moment,
      showTimePanel: false,
      showTimeRangePanel: false,
      isHideShow: false,
      isHideShowPk: false,
      vm: this,
      userData: JSON.parse(localStorage.getItem("userData")),

      locationsByUser: [],

      request_quotation: {
        isHideShows: false,
        isHideShowPks: false,
        other_pickup_location: null,
        other_delivery_location: null,
        pickup_location: null,
        delivery_location: null,
        other_pickup_region: null,
        other_delivery_region: null,
        pickup_region: null,
        delivery_region: null,
        company_id: null,
        customer_id: null,
        service_type: null,
        pod_port: null,
        pol_port: null,
        incoterms: null,
        cont_type: null,
        goods_type: null,
        package_type: null,
        transport_type: null,
        deport: null,
        business_type: null,
        so_luong: null,
        trong_luong: null,
        mo_ta: null,
        volume: null,
        from_date: null,
        to_date: null,
        other_service: null,
        notes: null,
        so_khoi: null,
        so_kien: null,
        totalChargeWeight: null,
        size_: {
          length_: null,
          width_: null,
          height_: null,
        },
        customs_addr: null,
        hs_code: null,
      },
      customer_list_options: null,

      volumes: [
        { id: 1, text: "1-10" },
        { id: 2, text: "10-30" },
        { id: 3, text: "30-50" },
        { id: 4, text: "50-100" },
        { id: 5, text: ">100" },
      ],
      currencies: [
        { id: "VND", text: "VNĐ" },
        { id: "USD", text: "USD" },
      ],
      dropzoneOptions: {
        url: $ctx.API_URL + this.$Utils.CONSTANTS.TYPE_UPLOAD.URL,
        addRemoveLinks: !this.readonly,
        acceptedFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.type,
        maxFilesize: this.$Utils.CONSTANTS.TYPE_UPLOAD.size,
        maxFiles: this.$Utils.CONSTANTS.TYPE_UPLOAD.max,
        headers: { apiKey: localStorage.getItem("accessToken") },
        clickable: !this.readonly,
      },
      customer_list: null,
      useName: null,
      costs: [],

      countRq: 0,
    };
  },
  mounted() {
    const booking_note = JSON.parse(this.request.booking_note);
    this.request_quotation.service_type = this.request.service_type_id;
    this.request_quotation.notes = booking_note.note;
    this.request_quotation.id = this.request.bookingID;
    this.request_quotation.bookingId = this.request.bookingID;
    this.request_quotation.booking_date = booking_note.booking_date;
    this.request_quotation.booking_no = booking_note.booking_no;
    this.request_quotation.closing_time = booking_note.closing_time;
    this.request_quotation.company_id = booking_note.company_id;
    this.request_quotation.contact = booking_note.contact;
    this.request_quotation.customer_email = booking_note.customer_email;
    this.request_quotation.customer_id = booking_note.customer_id;
    this.request_quotation.cut_si_vgm = booking_note.cut_si_vgm;
    this.request_quotation.eta = booking_note.eta;
    this.request_quotation.etd = booking_note.etd;
    this.request_quotation.goods_type = booking_note.goods_type;
    this.request_quotation.packageNumber = booking_note.packageNumber;
    this.request_quotation.placeOfDelivery = booking_note.placeOfDelivery;
    this.request_quotation.place_of_stuffing = booking_note.place_of_stuffing;
    this.request_quotation.pod_port = this.request.pod_code;
    this.request_quotation.pol_port = this.request.pol_code;
    this.request_quotation.sale_id = booking_note.sale_id;
    this.request_quotation.shipping_line = booking_note.shipping_line;
    this.request_quotation.so_khoi = booking_note.so_khoi;
    this.request_quotation.trong_luong = booking_note.trong_luong;
    this.request_quotation.vessel = booking_note.vessel;

    this.request_quotation.company_name = booking_note.company_name;
    this.request_quotation.customer_name = booking_note.customer_name;
    this.request_quotation.sale_name = booking_note.sale_name;

    this.request_quotation.vessel_name = booking_note.vessel_name;

    this.request_quotation.pol_name = booking_note.pol_name;
    this.request_quotation.pod_name = booking_note.pod_name;
    this.request_quotation.placeOfDelivery_name =
      booking_note.placeOfDelivery_name;
    this.request_quotation.goods_type_name = booking_note.goods_type_name;

    this.request_quotation.place_of_stuffing_name =
      booking_note.place_of_stuffing_name;
  },
  methods: {
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleCloseChange() {
      this.$refs.datePicker.popupVisible = false;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    formatOption(arr) {
      const mapData = arr.map((obj) => {
        obj.text = obj.text || obj.name;
        obj.id = obj.code;
        return obj;
      });
      return mapData;
    },
    async getDataPolPod() {
      try {
        const data = await this.$store.dispatch("masterData/fetchPortsType");
        if (data && data.result == 1) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("Successfully synchronized to FAST"),
              icon: "CheckSquareIcon",
              variant: "primary",
            },
          });
        } else {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$i18n.t("quotationSaveError"),
              icon: "AlertTriangleIcon",
              variant: "danger",
            },
          });
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: error.message,
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      }
    },
  },
};
</script>
 
<style>
.red {
  color: red;
}

.check_input {
  width: 10%;
  margin-left: 30px;
}
</style>